/* Pure Madness – lett JS oppå Dawn. Ingen biblioteker. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Kunngjøringsstripe: roter hvert 4. sekund ---------- */
  document.querySelectorAll('[data-pm-announce]').forEach((bar) => {
    const items = bar.querySelectorAll('.pm-announce__item');
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Scroll-reveal ---------- */
  const reveals = document.querySelectorAll('.pm-reveal');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((el) => el.classList.add('is-visible'));
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12 }
    );
    reveals.forEach((el) => io.observe(el));
  }

  /* ---------- Tellere (trær, 7×, 5×) ---------- */
  const formatNumber = (n) => Math.round(n).toLocaleString('nb-NO');
  const counters = document.querySelectorAll('[data-pm-count]');
  const runCounter = (el) => {
    const target = parseFloat(el.dataset.pmCount) || 0;
    const suffix = el.dataset.pmSuffix || '';
    if (reduceMotion) {
      el.textContent = formatNumber(target) + suffix;
      return;
    }
    const start = performance.now();
    const duration = 1600;
    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      el.textContent = formatNumber(target * eased) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  if ('IntersectionObserver' in window) {
    const cio = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          runCounter(entry.target);
          cio.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );
    counters.forEach((el) => cio.observe(el));
  } else {
    counters.forEach(runCounter);
  }

  /* ---------- Parallax på store bilder (kun desktop, kun transform) ---------- */
  const parallaxEls = document.querySelectorAll('.pm-parallax');
  if (parallaxEls.length && !reduceMotion && window.matchMedia('(min-width: 990px)').matches) {
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      parallaxEls.forEach((el) => {
        const rect = el.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        const offset = (rect.top + rect.height / 2 - vh / 2) * -0.15;
        el.style.transform = `translate3d(0, ${Math.max(-40, Math.min(40, offset))}px, 0) scale(1.08)`;
      });
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  /* ---------- Header-skygge når man har scrollet ---------- */
  const onScroll = () => document.body.classList.toggle('pm-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Toast ---------- */
  let toastTimer;
  const toast = (text) => {
    let el = document.querySelector('.pm-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'pm-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML = '<span></span><button type="button">Se kurv</button>';
      el.querySelector('button').addEventListener('click', () => {
        el.classList.remove('is-visible');
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.open();
        else window.location.href = window.routes?.cart_url || '/cart';
      });
      document.body.appendChild(el);
    }
    el.querySelector('span').textContent = text;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  };
  window.pmToast = toast;

  const bumpBadge = () => {
    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble || reduceMotion) return;
    bubble.classList.remove('pm-bump');
    void bubble.offsetWidth;
    bubble.classList.add('pm-bump');
  };

  /* Oppdater skuff og kurvikon uten å åpne skuffen. */
  const refreshCartSections = async () => {
    const res = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
    const sections = await res.json();
    const parse = (html, selector) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    const drawerHtml = parse(sections['cart-drawer'], '#CartDrawer');
    const drawer = document.querySelector('#CartDrawer');
    if (drawer && drawerHtml) {
      drawer.innerHTML = drawerHtml.innerHTML;
      document.querySelector('cart-drawer')?.classList.remove('is-empty');
      document.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () =>
        document.querySelector('cart-drawer')?.close()
      );
    }
    const bubble = document.getElementById('cart-icon-bubble');
    const bubbleHtml = parse(sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && bubbleHtml) bubble.innerHTML = bubbleHtml.innerHTML;
  };

  /* ---------- Hurtigkjøp «+» på produktkort og «Legg i kurv» i prismerket ---------- */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pm-quick-add]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    const original = button.innerHTML;
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.pmQuickAdd), quantity: 1 }] }),
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      await refreshCartSections();
      bumpBadge();
      button.classList.add('is-added');
      button.innerHTML = button.dataset.pmAddedLabel || '✓';
      toast(`${button.dataset.pmTitle || 'Varen'} ligger i kurven. Ett tre til plantet 🤙`);
      setTimeout(() => {
        button.classList.remove('is-added');
        button.innerHTML = original;
      }, 1400);
    } catch (error) {
      toast(error.message || 'Noe gikk galt. Prøv igjen.');
      button.innerHTML = original;
    } finally {
      button.removeAttribute('aria-busy');
    }
  });

  /* Dawn-skjemaet på produktsiden: sprett kurvikonet når noe legges til. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'product-form') setTimeout(bumpBadge, 50);
    });
  }

  /* ---------- Fast kjøpsknapp på mobil ---------- */
  const sticky = document.querySelector('[data-pm-sticky-atc]');
  const mainButton = document.querySelector('.product-form__submit');
  if (sticky && mainButton && 'IntersectionObserver' in window) {
    const stickyButton = sticky.querySelector('button');
    let seenForm = false;
    // Vises så lenge den vanlige kjøpsknappen ikke er på skjermen (både før og etter).
    const sio = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) seenForm = true;
        const show = !entry.isIntersecting;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyButton?.hasAttribute('data-pm-sticky-choose') && seenForm) stickyButton.textContent = 'Legg i kurv';
      },
      { threshold: 0 }
    );
    sio.observe(mainButton);
    stickyButton?.addEventListener('click', () => {
      // Har produktet størrelser og kunden ikke har sett valget ennå: rull dit i stedet for å legge i kurv.
      if (stickyButton.hasAttribute('data-pm-sticky-choose') && !seenForm) {
        const picker = document.querySelector('variant-selects, .product-form__input') || mainButton;
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainButton.click();
    });
  }

  /* ---------- Gavehilsen i kurven ---------- */
  document.addEventListener('change', (event) => {
    const toggle = event.target.closest('[data-pm-gift-toggle]');
    if (!toggle) return;
    const wrap = document.querySelector('[data-pm-gift-note]');
    if (!wrap) return;
    const textarea = wrap.querySelector('textarea');
    wrap.hidden = !toggle.checked;
    if (toggle.checked) {
      textarea?.focus();
    } else if (textarea && textarea.value) {
      textarea.value = '';
      textarea.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });
})();

/* Produktbeskrivelse: «Les mer» utvider teksten der den står. */
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-pm-desc-toggle]');
  if (!toggle) return;
  const wrap = toggle.closest('.pm-desc');
  const full = wrap.querySelector('[data-pm-desc-full]');
  const short = wrap.querySelector('[data-pm-desc-short]');
  const open = toggle.getAttribute('aria-expanded') === 'true';
  full.hidden = open;
  short.hidden = !open;
  toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
  toggle.textContent = open ? 'Les mer' : 'Vis mindre';
});

/* ---------- Norsk datoformat på Judge.me-anmeldelser (24.02.2025) ---------- */
(() => {
  // Judge.me skriver datoen på nytt etter innlasting, så vi retter den hver gang teksten endres.
  const fix = () => {
    document.querySelectorAll('.jdgm-rev__timestamp[data-content]').forEach((el) => {
      const m = el.getAttribute('data-content').match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!m) return;
      const nb = `${m[3]}.${m[2]}.${m[1]}`;
      if (el.textContent !== nb) el.textContent = nb;
    });
  };
  const start = () => {
    fix();
    new MutationObserver(fix).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---------- Ingen forhåndsvalgt størrelse ----------
   Dawn velger første størrelse (S) automatisk. Da bestiller noen feil størrelse uten å merke det.
   Har produktet bare størrelsesvalg og kunden ikke kom via en ?variant=-lenke, fjerner vi valget
   og låser kjøpsknappen til en størrelse er valgt. */
(() => {
  const picker = document.querySelector('variant-selects');
  if (!picker || /[?&]variant=/.test(location.search)) return;
  const fieldsets = picker.querySelectorAll('fieldset');
  if (fieldsets.length !== 1) return;
  const legend = (fieldsets[0].querySelector('legend')?.textContent || '').trim().toLowerCase();
  if (!/størrelse|size/.test(legend)) return;
  const radios = [...fieldsets[0].querySelectorAll('input[type="radio"]')];
  if (radios.length < 2) return;

  const form = document.querySelector('product-form form');
  const buttons = () => document.querySelectorAll('.product-form__submit');
  let chosen = false;

  radios.forEach((r) => { r.checked = false; });
  buttons().forEach((b) => {
    b.dataset.pmNoSize = '1';
    const label = b.querySelector('span');
    if (label) { b.dataset.pmLabel = label.textContent; label.textContent = 'Velg størrelse'; }
  });

  const remind = () => {
    fieldsets[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    fieldsets[0].classList.remove('pm-pick-size');
    void fieldsets[0].offsetWidth;
    fieldsets[0].classList.add('pm-pick-size');
  };

  // Stopp kjøp før størrelse er valgt (gjelder også den faste knappen nederst på mobil).
  document.addEventListener('click', (e) => {
    if (chosen) return;
    const btn = e.target.closest('.product-form__submit');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    remind();
  }, true);
  form?.addEventListener('submit', (e) => {
    if (chosen) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    remind();
  }, true);

  fieldsets[0].addEventListener('change', () => {
    chosen = true;
    buttons().forEach((b) => {
      const label = b.querySelector('span');
      if (label && b.dataset.pmLabel && label.textContent === 'Velg størrelse') label.textContent = b.dataset.pmLabel;
      delete b.dataset.pmNoSize;
    });
  });
})();
